export const GET_ALL_DESIGNER_DISCOUNT_BANNER_REQUEST = "GET_ALL_DESIGNER_DISCOUNT_BANNER_REQUEST";
export const GET_ALL_DESIGNER_DISCOUNT_BANNER_FAILURE = "GET_ALL_DESIGNER_DISCOUNT_BANNER_FAILURE";
export const GET_ALL_DESIGNER_DISCOUNT_BANNER_SUCCESS = "GET_ALL_DESIGNER_DISCOUNT_BANNER_SUCCESS";

export const CREATE_DESIGNER_DISCOUNT_BANNER_REQUEST = "CREATE_DESIGNER_DISCOUNT_BANNER_REQUEST";
export const CREATE_DESIGNER_DISCOUNT_BANNER_FAILURE = "CREATE_DESIGNER_DISCOUNT_BANNER_FAILURE";
export const CREATE_DESIGNER_DISCOUNT_BANNER_SUCCESS = "CREATE_DESIGNER_DISCOUNT_BANNER_SUCCESS";

export const UPDATE_DESIGNER_DISCOUNT_BANNER_REQUEST = "UPDATE_DESIGNER_DISCOUNT_BANNER_REQUEST";
export const UPDATE_DESIGNER_DISCOUNT_BANNER_FAILURE = "UPDATE_DESIGNER_DISCOUNT_BANNER_FAILURE";
export const UPDATE_DESIGNER_DISCOUNT_BANNER_SUCCESS = "UPDATE_DESIGNER_DISCOUNT_BANNER_SUCCESS";

export const DELETE_DESIGNER_DISCOUNT_BANNER_REQUEST = "DELETE_DESIGNER_DISCOUNT_BANNER_REQUEST";
export const DELETE_DESIGNER_DISCOUNT_BANNER_FAILURE = "DELETE_DESIGNER_DISCOUNT_BANNER_FAILURE";
export const DELETE_DESIGNER_DISCOUNT_BANNER_SUCCESS = "DELETE_DESIGNER_DISCOUNT_BANNER_SUCCESS";